import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

interface CountUpProps {
  start?: number;
  end: number;
  duration?: number;
  className?: string;
}

const CountUp: React.FC<CountUpProps> = ({
  start = 0,
  end,
  duration = 2,
  className = "",
}) => {
  const numberRef = useRef<HTMLSpanElement>(null);
  const containerRef = useRef<HTMLSpanElement>(null);

  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const element = containerRef.current;

    if (!element || hasAnimated) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasAnimated(true);

          const counter = { value: start };

          gsap.to(counter, {
            value: end,
            duration,
            ease: "power2.out",

            onUpdate: () => {
              if (numberRef.current) {
                numberRef.current.textContent = Math.floor(
                  counter.value,
                ).toLocaleString();
              }
            },

            onComplete: () => {
              if (numberRef.current) {
                numberRef.current.textContent = end.toLocaleString();
              }
            },
          });

          observer.disconnect();
        }
      },
      {
        threshold: 0.3,
      },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [start, end, duration, hasAnimated]);

  return (
    <span ref={containerRef} className={className}>
      <span ref={numberRef}>{start}</span>
    </span>
  );
};

export default CountUp;
